import { useEffect, useRef, useState } from "react";

// Sizes an element to exactly fill the space between its top edge and the mobile bottom nav,
// tracking the on-screen keyboard; also locks page scrolling so only inner panes scroll.
export const useFitHeight = () => {
  const ref = useRef(null);
  const [h, setH] = useState(null);
  useEffect(() => {
    const vv = window.visualViewport;
    const fit = () => {
      const el = ref.current;
      if (!el) return;
      const nav = document.querySelector('[data-testid="mobile-bottom-nav"]');
      const navH = nav && getComputedStyle(nav).display !== "none" ? nav.getBoundingClientRect().height : 0;
      const viewH = vv ? vv.height : window.innerHeight;
      const keyboardOpen = vv && window.innerHeight - vv.height > 120;
      const top = el.getBoundingClientRect().top + window.scrollY;
      const bottomGap = keyboardOpen ? 0 : navH || (window.innerWidth >= 768 ? 24 : 0);
      setH(Math.max(260, Math.round(viewH - top - bottomGap)));
    };
    window.scrollTo(0, 0);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    fit();
    const t = setTimeout(fit, 300);
    window.addEventListener("resize", fit);
    vv?.addEventListener("resize", fit);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
      window.removeEventListener("resize", fit);
      vv?.removeEventListener("resize", fit);
    };
  }, []);
  return [ref, h];
};
